import React from 'react';

import { TypeOfTranscript } from 'js/src/data/transcript/transcript-types';

export const MAIN_TRANSCRIPT_CONTEXT_VALUE = {
    typeOfTranscript: TypeOfTranscript.MEDIA_TRANSCRIPT_TAB,
};

export const TranscriptContext = React.createContext({
    typeOfTranscript: TypeOfTranscript.MEDIA_TRANSCRIPT_TAB,
});
